import { createRef, useEffect, useRef, useState, type RefObject } from "react";
import { Button } from "antd";
import { RcFile } from "antd/es/upload";
import { UseFormGetValues, UseFormSetValue, useWatch } from "react-hook-form";
import "@/entities/journal";
import { SectionFourDocTypeEnum, SectionFourDocTypeTypes } from "../../../../model/types/documents-four-enum";
import { FormFileSelectorFour } from "./ui/form-file-selector-four/form-file-selector-four";
import SectionDocumentItem from "./ui/section-document-item/section-document-item";
import "./section-document-four-list.scss";

export const SectionDocumentFourList = ({
  isInfo,
  setValue,
  errors,
  getValues,
  uploadConfigFour,
  control,
  isOtherDocs,
  isMultiple,
  uploadConfigMultiFour,
  title,
  fieldName = "itemPartOne",
  documentFieldKey = "otherDocuments",
}: {
  isInfo?: boolean;
  setValue?: UseFormSetValue<any>;
  errors?: any;
  getValues?: UseFormGetValues<any>;
  uploadConfigFour?: any[];
  control: any;
  isOtherDocs?: boolean;
  isMultiple?: boolean;
  uploadConfigMultiFour?: any[];
  title?: string;
  fieldName?: string;
  documentFieldKey?: string;
}) => {
  const watchedDocs = useWatch({ name: "docs", control });
  const watchedDocsMeta = useWatch({
    name: `${fieldName}.${documentFieldKey}`,
    control,
  });
  const [selectedDocType, setSelectedDocType] = useState<string | null>(
    SectionFourDocTypeTypes.BUILT_SCHEME,
  );
  const [localFiles, setLocalFiles] = useState<RcFile[]>([]);

  const itemRefs = useRef<Record<SectionFourDocTypeEnum, RefObject<any>>>(
    // @ts-expect-error динамические ref по docType не типизированы в Record
    {},
  );

  useEffect(() => {
    uploadConfigMultiFour
      ?.filter(
        ({ docType }) => docType !== SectionFourDocTypeTypes.SUPPORTING_DOC,
      )
      .forEach(({ docType }) => {
        // @ts-expect-error динамические ref по docType не типизированы в Record
        if (!itemRefs.current[docType]) {
          // @ts-expect-error динамические ref по docType не типизированы в Record
          itemRefs.current[docType] = createRef();
        }
      });
    
  // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const docs = getValues?.(`${fieldName}.${documentFieldKey}`) || [];
    const rawFiles = getValues?.(`${fieldName}.files`) || [];

    const restoredFiles: RcFile[] = docs.map((doc: any, index: number) => {
      const f = doc.fileMetadata;
      const realFile = rawFiles[index];

      if (realFile instanceof File) {
        return realFile as RcFile;
      }

      return {
        uid: f?.fileId || f?.id || `restored-${index}`,
        name: f?.fileName || `Файл ${index + 1}`,
        size: 0,
        type: f?.fileType || "application/octet-stream",
        lastModified: Date.now(),
      } as RcFile;
    });
    setLocalFiles(restoredFiles);
  // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedDocsMeta]);

  const handleFilesChange = (files: RcFile[]) => {
    const prevMeta = getValues?.(`${fieldName}.${documentFieldKey}`) || [];

    const mappedMeta = files.map((file, index) => {
      const existing = prevMeta[index];
      if (existing?.fileMetadata?.id || existing?.fileMetadata?.fileId) {
        return existing;
      }
      return {
        fileMetadata: {
          fileNumber: index,
          fileName: file.name,
          fileType: file.type,
          fileContentLength: file.size,
        },
      };
    });

    const strippedFiles = files.map((file) =>
      // @ts-expect-error originFileObj отсутствует в типе UploadFile
      file?.originFileObj instanceof File ? file?.originFileObj : file,
    );

    setLocalFiles(files);
    setValue?.(`${fieldName}.${documentFieldKey}`, mappedMeta);
    setValue?.(`${fieldName}.files`, strippedFiles);
  };

  const hasNoRegulationDoc = !!(
    Array.isArray(watchedDocs) &&
    watchedDocs.some(
      (doc: any) => doc.docType === SectionFourDocTypeTypes.REGULATION_DOC,
    )
  );

  return (
    <div className="journal-document-list-panel">
      <div className="journal-document-block-title">{title || "Документы"}</div>

      {isMultiple ? (
        <>
          <div className="journal-document-type-options">
            {!isInfo &&
              uploadConfigMultiFour
                ?.filter(
                  ({ docType }) =>
                    docType !== SectionFourDocTypeTypes.SUPPORTING_DOC,
                )
                .map(({ docType, title }) => (
                  <div key={docType} className="journal-document-type-option">
                    <input
                      type="radio"
                      name="docTypeRadio"
                      value={docType}
                      checked={selectedDocType === docType}
                      onChange={() => setSelectedDocType(docType)}
                      className="journal-document-type-radio"
                    />
                    {title}
                  </div>
                ))}
          </div>
          {!isInfo && (
            <div className="journal-document-add-actions">
              <Button
                onClick={() => {
                  // @ts-expect-error динамические ref по docType не типизированы в Record
                  itemRefs.current?.[selectedDocType]?.current?.openModal();
                }}
              >
                Добавить документ
              </Button>
              {/* {errors?.docs?.message && shouldShowWarning && (
                <div style={{ color: "red", marginBottom: "8px" }}>
                  Введите информацию о документе
                </div>
              )} */}
            </div>
          )}
          {uploadConfigMultiFour
            ?.filter(
              ({ docType }) => docType !== SectionFourDocTypeTypes.SUPPORTING_DOC,
            )
            .map(({ title, docType }) => {
              const shouldShow = watchedDocs?.some(
                (doc: any) => doc.docType === docType,
              );
              return (
                <>
                  <SectionDocumentItem
                    isCollapsed={!shouldShow}
                    control={control}
                    key={docType}
                    title={title}
                    docType={docType}
                    setValue={setValue}
                    isInfo={isInfo}
                    // formDocs={formDocs}
                    // getValues={getValues}
                    // @ts-expect-error динамические ref по docType не типизированы в Record
                    ref={itemRefs.current?.[docType]}
                  />
                </>
              );
            })}
        </>
      ) : (
        uploadConfigFour?.map(({ title, docType, optional }) => (
          <>
            {errors?.docs?.root?.message &&
              !hasNoRegulationDoc &&
              docType === SectionFourDocTypeTypes.REGULATION_DOC && (
                <div className="journal-document-validation-error">
                  Введите информацию о документе
                </div>
              )}
            <SectionDocumentItem
              control={control}
              key={docType}
              title={`${title}${optional ? " (необязательно)" : ""}`}
              docType={docType}
              setValue={setValue}
              isInfo={isInfo}
              // formDocs={formDocs}
              // getValues={getValues}
            />
          </>
        ))
      )}

      {!isOtherDocs ? null : (
        <div className="document-container">
          <div>Дополнительные файлы (необязательно)</div>
          <FormFileSelectorFour
            files={localFiles}
            filesMeta={watchedDocsMeta || []}
            onFilesChange={handleFilesChange}
            isInfo={isInfo}
          />
        </div>
      )}
    </div>
  );
};
